module.exports = __webpack_public_path__ + "notification.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-notifications/lib/fonts/notification.woff?s3g3t9
 ** module id = 512
 ** module chunks = 0
 **/